const DAY = 24 * 60 * 60 * 1000;
const DELETE_DATE = 'Thu, 01 Jan 1970 00:00:01 GMT';

/**
 * Get a cookie by name.
 *
 * @since 5.0.X
 *
 * @param   {string}      name The name of the cookie to retrieve.
 * @returns {string|null}      Returns the value of a cookie or null if the cookie doesn't exist.
 */
const get = (name) => {
	let n = name + '=';
	let ca = document.cookie.split(';');

	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (' ' === c.charAt(0)) {
			c = c.substring(1, c.length);
		}
		if (0 === c.indexOf(n)) {
			return c.substring(n.length, c.length);
		}
	}

	return null;
};

/**
 * Gets expiration date string from value.
 *
 * @since  5.0.X
 *
 * @param  {mixed} val Number for days, Date object for custom, or UTC time string.
 *
 * @returns {string}    The UTC time string.
 */
const expires = (val) => {
	if ('number' === typeof val) {
		val = ((d) => d.setTime(d.getTime() + val * DAY) && d)(new Date());
	}

	if (val instanceof Date) {
		val = val.toUTCString();
	}

	return val;
};

/**
 * Create a cookie.
 *
 * @since 5.0.X
 *
 * @param   {string}  name  The name of the cookie to create.
 * @param   {string}  value The value of the cookie.
 * @param   {number}  days  The length of time this cookie will last in days.
 * @param   {boolean} cross Whether or not this cookie needs to work across domains.
 * @returns {void}
 */
const create = (name, value, days = 365, cross = false) => {
	value = 'object' === typeof value ? JSON.stringify(value) : value;

	// If we have a days value, set it in the expiry of the cookie.
	let exp = '';
	if (days || '0' === days) {
		// If -1 or 0 is our value, set a session based cookie instead of a persistent cookie.
		if ('-1' === days || '0' === days) {
			exp = '';
		} else {
			exp = '; expires=' + expires(days);
		}
	} else {
		exp = `; expires=${DELETE_DATE}`;
	}

	let cookie = name + '=' + value + exp + '; path=/'; // eslint-disable-line one-var
	if (cross) {
		cookie += ';domain=.' + domain();
	}

	// Write the cookie.
	document.cookie = cookie;
};

/**
 * Delete a cookie by name.
 *
 * @since 5.0.X
 *
 * @param   {string}  name  The name of the cookie being deleted.
 * @param   {boolean} cross Whether or not cookie is set across domains.
 *
 * @returns {void}
 */
const remove = (name, cross = false) => create(name, '', 0, cross);

/**
 * Get the base domain name for a cookie.
 *
 * @since 5.0.0
 *
 * @returns {string} The current domain in a way that cookies like.
 */
const domain = () => {
	let tmp = 'tmp_get_base_domain=';
	let hostname = document.location.hostname.split('.');
	let baseDomain;

	// Loop for each segment of the hostname (starting from the right)
	for (let i = hostname.length - 1; 0 <= i; i--) {
		baseDomain = hostname.slice(i).join('.');

		// If the temp cookie was created successfully then the base domain is good
		if (test(`${tmp}cookie`, baseDomain)) {
			// Delete the temp
			test(tmp, baseDomain, true);

			// And send back the domain.
			return baseDomain;
		}
	}
};

/**
 * Checks whether or not cookies are enabled.
 *
 * @since 5.0.X
 *
 * @returns {boolean} Are cookies enabled or not?
 */
const enabled = () => {
	return 'undefined' !== typeof navigator.cookieEnabled ? !!navigator.cookieEnabled : test('testcookie');
};

/**
 * Sets a cookie and tests if it exists. For temp. cookies.
 *
 * @since  5.0.X
 *
 * @param  {string} name   The cookie name.
 * @param  {string} domain The domain to set for the cookie.
 * @param  {boolean} del   Whether to delete this cookie.
 *
 * @returns {boolean} Whether Cookie was set.
 */
const test = (name, domain, del) => {
	document.cookie = `${name}${domain ? `;domain=.${domain};` : ''}${del ? `;expires=${DELETE_DATE};` : ''}`;
	return -1 < document.cookie.indexOf(name);
};

export { get, create, expires, remove, domain, enabled, test };
